import React, { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Box,
} from "@mui/material";
import { CircularProgressCustom } from "../../utils/muiCustomTheme";
// import campaignIconScheduled from "../../assets/icons/icon-campaing-scheduled.svg";
// import campaignIconError from "../../assets/icons/icon-campaing-error.svg";
// import campaignIconSend from "../../assets/icons/icon-campaing-send.svg";
// import campaignIconDelete from "../../assets/icons/Icon-delete.svg";

interface SegmentUsageTableProps {
  data?: any;
  isLoading?: boolean;
}

const SegmentUsageTable: React.FC<SegmentUsageTableProps> = ({ data, isLoading }) => {
  const tableData = useMemo(() => {
    const usageData = data?.Usage;
    return Array.isArray(usageData) ? usageData : [];
  }, [data]);

  const columns = useMemo(() => {
    if (tableData.length === 0) return [];
    return Object.keys(tableData[0]).map((key) => ({ field: key, headerName: key }));
  }, [tableData]);

  const { colWidths, otherColWidth } = useMemo(() => {
    const colWidthsLocal: Record<string, string> = {
      Segmentname: "20%",
      Destinations: "30%",
    };

    const fixedCols = Object.keys(colWidthsLocal);
    const usedWidth = Object.values(colWidthsLocal).reduce(
      (acc, val) => acc + Number(val.replace("%", "")),
      0
    );
    const remainingWidth = 100 - usedWidth;

    const otherCols = columns.filter((col) => !fixedCols.includes(col.field));
    const otherColWidthLocal =
      otherCols.length > 0 ? `${remainingWidth / otherCols.length}%` : `${remainingWidth}%`;

    return { colWidths: colWidthsLocal, otherColWidth: otherColWidthLocal };
  }, [columns]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
        <CircularProgressCustom />
      </Box>
    );
  }

  if (!tableData.length) {
    return (
      <div className="create-campaign__delivery-preview__status">
        No campaign usage found for this segment
      </div>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table sx={{ tableLayout: "fixed", width: "100%" }}>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell
                key={col.field}
                sx={{
                  width: colWidths[col.field] || otherColWidth,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  fontWeight: 600,
                }}
              >
                {col.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {tableData.map((row: Record<string, any>, rowIndex: number) => (
            <TableRow
              key={rowIndex}
              sx={{
                "&:hover": {
                  backgroundColor: "#FFEBF5",
                },
              }}
            >
              {columns.map((col) => (
                <TableCell
                  key={col.field}
                  sx={{
                    width: colWidths[col.field] || otherColWidth,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {row[col.field] || "-"}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SegmentUsageTable;
